import React, { useContext, useState, useEffect } from "react"

// Lib

import { auth } from "@lib/firebase"

// Components
import Metatags from "@components/Metatags"
import Headline from "@components/Headline"

// Forms

// Views
import AppPanel from "@views/AppPanel"
import BetaAccess from "@views/BetaAccess"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({}))

function BetaAccessPage() {
    const classes = useStyles()

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        setLoading(true)
        if (typeof window !== "undefined") {
            // Confirm the link is a sign-in with email link.
            if (auth.isSignInWithEmailLink(window.location.href)) {
                // Additional state parameters can also be passed via URL.
                // This can be used to continue the user's intended action before triggering
                // the sign-in operation.
                // Get the email if available. This should be available if the user completes
                // the flow on the same device where they started it.
                let email = window.localStorage.getItem("emailForSignIn")
                if (!email) {
                    // User opened the link on a different device. To prevent session fixation
                    // attacks, ask the user to provide the associated email again. For example:
                    email = window.prompt("Please provide your email for confirmation")
                }
                // The client SDK will parse the code from the link for you.
                auth.signInWithEmailLink(email, window.location.href)
                    .then((result) => {
                        // Clear errors
                        setError(null)

                        // Clear email from storage.
                        window.localStorage.removeItem("emailForSignIn")

                        // You can access the new user via result.user
                        // Additional user info profile not available via:
                        // result.additionalUserInfo.profile == null
                        // You can check if the user is new or existing:
                        // result.additionalUserInfo.isNewUser
                    })
                    .catch((error) => {
                        setError(error)
                        //console.log(error)
                        // Some error occurred, you can inspect the code: error.code
                        // Common errors could be invalid email and invalid or expired OTPs.
                    })
            }
        }
        setLoading(false)
    }, [])

    // 1. user signed out <SignInForm />
    // 2. user signed in, but missing username <UsernameForm />
    // 3. user signed in, has username <SignOutButton />

    return (
        <React.Fragment>
            <Metatags subtitle="Beta" path="beta" />
            <AppPanel>
                <Headline>Hello Friend 🎉</Headline>
                <BetaAccess loading={loading} error={error}></BetaAccess>
            </AppPanel>
        </React.Fragment>
    )
}

export default BetaAccessPage
